<template>
    <v-container fluid class="pa-0">
        <v-toolbar color="grey-lighten-3">
            <v-toolbar-title class="text-h6 font-weight-medium">
                Gmail Integration
            </v-toolbar-title>
        </v-toolbar>
        <div v-if="loading">
            <v-skeleton-loader type="article"></v-skeleton-loader>
        </div>
        <div v-else>

            <div v-if="!authenticated">
                <v-banner class="my-4" color="warning" icon="$warning" lines="three">
                    <v-banner-text>
                        Authenticate with Google to enable Gmail integration for this client.<br>
                        It will fetch last one year emails.
                    </v-banner-text>

                    <template v-slot:actions>
                        <v-btn @click="handleAuth($event)">Authenticate with Google!</v-btn>
                    </template>
                </v-banner>
            </div>
           
            <!-- Progress display for email fetching -->
            <v-card v-else-if="emailFetchProgress.progress > 0 && emailFetchProgress.progress < 100 && !fetched" class="my-4 pa-4">
                <v-card-title>Email Fetch Progress</v-card-title>
                <v-card-text>
                    <v-progress-linear
                        v-model="emailFetchProgress.progress"
                        color="primary"
                        height="20"
                        striped
                        rounded
                    >
                        <strong>{{ Math.floor(emailFetchProgress.progress) }}%</strong>
                    </v-progress-linear>
                    <p class="mt-2">{{ emailFetchProgress.status }}</p>
                </v-card-text>
            </v-card>
            <v-banner v-else-if="emailFetchProgress.progress === 100" class="my-4" color="success" icon="$success" lines="one">
                <v-banner-text>
                    Email fetching completed successfully!
                </v-banner-text>
            </v-banner>
             <div v-else>
                <v-banner class="my-4" color="success" icon="$success" lines="three">
                    <v-banner-text>
                        Last synced at: <strong>{{ simpleDateTimeFormat(lastsynctime) }} </strong><br>
                        if you're not seeing recent emails, please re-authenticate.
                    </v-banner-text>

                    <template v-slot:actions>
                        <v-btn @click="handleAuth($event)">Re-Authenticate with Google!</v-btn>
                    </template>
                </v-banner>
            </div>

        </div>
    </v-container>
</template>

<script>
import axios from 'axios';
import MiscService from '@/services/miscService';
import dayjsMixin from "@/mixins/dayjsMixin";
import { mapGetters } from "vuex";
import EventBus from "@/eventBus";
export default {
    name: "GmailIntegration",
    mixins: [dayjsMixin],
    data() {
        return {
            loading: true,
            oauthUrl: "",
            authenticated: false,
            lastsynctime: null,
            fetched : false,
        };
    },
    computed:{
        ...mapGetters(["clientId", "emailFetchProgress"]),
    },
    methods: {
        async handleAuth($event) {
            try {

                $event.preventDefault();
                let options = {
                    method: "GET",
                    url: process.env.VUE_APP_GOOGLE_AUTH_URL + "?client_id=" + this.clientId,
                    headers: {
                        "Content-type": "application/json",
                    }
                };
                const res = await axios.request(options);
                this.oauthUrl = res.data.url;

                const win = window.open(this.oauthUrl, "_blank");
            } catch (error) {
                console.error("Error during authentication:", error);
            }

        },
        // Future use: fetch threads, configure pubsub, fetch past emails
        // Review and use as needed
        // async handleFetch($event) {
        //     $event.preventDefault();
        //     let options = {
        //         method: "POST",
        //         url: process.env.VUE_APP_API_URL + "/api/mail/profile/threadslist",
        //         headers: {
        //             "Content-type": "application/json",
        //         },
        //         data: [
        //             { labelid: this.id }
        //         ]
        //     }
        //     let res = await axios.request(options);
        //     console.log("res.data = ", res.data);
        //     this.res = [...res.data];
        // },

        // async handleInit($event) {
        //     $event.preventDefault();
        //     let options = {
        //         method: "GET",
        //         url: process.env.VUE_APP_API_URL + "/api/mail/profile/labels",
        //         headers: {
        //             "Content-type": "application/json",
        //         },
        //     }
        //     let res = await axios.request(options);
        //     console.log(res.data);
        //     this.id = res.data.id;
        // },

        // async handleConfig($event) {
        //     console.log("Configure called");
        //     $event.preventDefault();
        //     let options = {
        //         method: "POST",
        //         url: process.env.VUE_APP_API_URL + "/api/mail/profile/configure",
        //         headers: {
        //             "Content-type": "application/json",
        //         },
        //     };
        //     await axios.request(options);
        // },

        // async fetchPastEmails($event) {
        //     $event.preventDefault();

        //     if (!this.validateEmail(this.emailInput)) {
        //         // If not valid, alert the user or handle the error accordingly
        //         alert("Please enter a valid email address");
        //         return;
        //     }

        //     let options = {
        //         method: "POST",
        //         url: process.env.VUE_APP_API_URL + "/api/mail/profile/fetchPast",
        //         headers: {
        //             "Content-type": "application/json",
        //         },
        //         data: {
        //             email: this.emailInput
        //         }
        //     };
        //     await axios.request(options);
        //     alert("Emails fetched successfully");
        //     this.emailInput = "";
        // },

    },
    async mounted() {
        try {
            let res = await MiscService.getSyncStatus();
            this.authenticated = res.data.authenticated;
            this.lastsynctime = res.data.date;
            this.fetched = res.data.fetched;
        } catch (error) {
            this.authenticated = false;
            console.error("Failed to fetch mail sync status:", error);
        }
        this.loading = false;

        EventBus.$on("emailSyncStatusUpdate", (status) => {
            if (status.authenticated !== undefined) {
                this.authenticated = status.authenticated;
            }
            if (status.lastsynctime !== undefined) {
                this.lastsynctime = status.lastsynctime;
            }
            if (status.fetched !== undefined) {
                this.fetched = status.fetched;
            }
        });
    },
     beforeUnmount() {
        EventBus.$off("emailSyncStatusUpdate");
    },
}
</script>

<style></style>